import React from "react";
import { injectIntl, WrappedComponentProps } from "gatsby-plugin-intl";
import { format } from "date-fns";

interface DateTimeFormatterProps extends WrappedComponentProps {
  date: string | Date;
}

export const isInvalidDate = (date: Date) => Number.isNaN(date.getTime());

const DateTimeFormatter: React.FC<DateTimeFormatterProps> = ({
  date,
  intl,
}) => {
  const parsedDate = date instanceof Date ? date : new Date(date); // Dateオブジェクトの場合はそのまま、文字列の場合はDateに変換

  // Dateが無効かチェック
  if (isInvalidDate(parsedDate)) {
    return "Invalid Date";
  }

  // Intl.DateTimeFormatを使う場合、XDのデザイン指示とは違うフォーマットになる
  // 言語ごとに日時の並びを調整する必要あり？
  // Intl.DateTimeFormatのコンストラクタ生成処理は重いので、ビルド時間を考慮するなら、
  // 　　date-fns+決め打ちのフォーマットで処理した方が良い
  // ref -> https://zenn.dev/mazamachi/articles/js-intl-date-time-format-performance

  // en -> 16 Feb 2024

  switch (intl.locale) {
    case "en":
      const formattedDate = format(new Date(date), "dd LLL yyyy");
      // console.log(`locale:${intl.locale}, raw:${date}, formatted:${formattedDate}`);
      return formattedDate;
    default:
      //TODO: 英語以外の言語の日時のフォーマットは要定義。
      return new Intl.DateTimeFormat(intl.locale, {
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(new Date(date));
  }
};

export default injectIntl(DateTimeFormatter);
